import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import 'bootstrap/dist/css/bootstrap.min.css'; 


import HomeHeader from "../header/HomeHeader";
import FooterMainView from "../footer/FooterMainView";
import PageTitle from "../common/PageTitle";
import WorkCenterView from "./WorkCenterView";
import New_helmet from "../New_helmet";

import work_1 from "../images/work/work_1.png"; 
import work_2 from "../images/work/work_2.jpeg"; 

import tran from "../images/work/tran.png"; 
import sub from "../images/work/sub.png"; 
import pro from "../images/work/pro.png";   

import DeviceUtils from "../../../helper/DeviceUtils";

const LeftThreeImage = () => {

    const imgWidth = (window.innerWidth - 40 );
 
    return <div style={{marginTop:"60px"}}>
        <div style={{marginBottom:"20px"}}>
            <img src={tran}  width={(DeviceUtils.isMobile()===true)?imgWidth:381}/>  
        </div>  
        <div style={{marginBottom:"20px"}}>
            <img src={sub}  width={(DeviceUtils.isMobile()===true)?imgWidth:381}/>  
        </div>  
        <div style={{marginBottom:"20px"}}>
            <img src={pro}  width={(DeviceUtils.isMobile()===true)?imgWidth:381}/>  
        </div>  
    </div>;
};


class WorkPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

    }
    render() { 

        return (
            <div id={"WorkPage"} className="overflow-hidden"  style={{backgroundColor: '#000000'}} >
                <New_helmet />

                <HomeHeader/>

                <FadeIn>
                    
                    <PageTitle title="WORK" /> 

                    <WorkCenterView
                    image={work_1}
                    title={"TAIWANESE FOOD NOTE"}
                    rightContent={<div>
                        Taiwan is famous for its distinctive culture as the island blends diversity in a harmonious way. A large part of the culture originates from the locals’ passion for food. In Taiwan, where food probably plays the most important role in daily life, you may see an eatery almost every three steps and a restaurant every five steps. Visitors are invited to explore an impressive variety from the tastes of Northern to Southern China, to local Taiwanese cuisines, to all kinds of exotic delicacies. In recent years, due to the rapid industrial development and economic growth, the business model of Chinese fast-food chain stores has also been developed, making the art of Taiwanese food more complex.
                        <br/><br/>
                        Sitting at the confluence of cultural exchange, Taiwan embraces foods from all over the world, such as American burgers, Italian pizzas, Japanese sashimi, German pork knuckles, Swiss cheeses... you name it. The island has become a hot destination for epicures, and the local cuisine is now a popular global phenomenon. Try it once, and it will be unforgettable forever.
                        <br/><br/>
                        Our goal is to promote the uniqueness of Taiwanese cuisine and the rich culture it presents.
                    </div>}
                    leftContent={<LeftThreeImage/>}
                    Name="Luna Huang"
                    buttons={<div>
                        <a target="_blank" href="https://www.youtube.com/playlist?list=PLsaY3aGaP5zIxHy9iZlzAiLKgcsxBOYxK" >
                            <button className="mt-5 py-2 px-3 mr-3 mainYellowBg border border-white" >
                                <b>Watch Now</b>
                            </button>  
                        </a> 
                    </div>}
                    />
 
                    <WorkCenterView
                    image={work_2}
                    title={"MASTERCLASS : TAIWAN"}
                    rightContent={
                        <div>
                        Following the historical context, the artistic elements of Taiwan’s society have been woven by Austronesian and indigenous cultures. Combined also with the characteristics and traditions from different provinces in China, various techniques and styles have then been developed.
                        <br/><br/>
                        As a blend of many ethnic groups, Taiwan has a deep foundation of art and literature with diverse expression and development. Especially in this generation, possibilities are unlimited varied from contemporary art to videos. We aim to record the spirit of creation and share cultural perceptions.
                        <br/><br/>
                        An interview program will be launched to invite videographers, artists and fashion designers to speak with their perspectives. We hope to promote various local and international art exchanges, sharing Taiwanese art with the world.
                    </div>}
                    leftContent={<LeftThreeImage/>}
                    Name="Sean Wang、Zhou Yongyou "
                    buttons={<div>
                        {/* <button
                            className="mt-5 py-2 px-3 mr-3 mainYellowBg border border-white"
                            ><b>Trailer</b></button> */}
                            <a target="_blank" href="https://www.youtube.com/playlist?list=PLsaY3aGaP5zLmcRBp89FPz9jUHmKtxNnM" >
                                <button className="mt-5 py-2 px-3 mainYellowBg border border-white" >
                                    <b>Watch Now</b>
                                </button>
                            </a>  
                    </div>}
                    />

                    <FooterMainView />
                </FadeIn>
            </div>
        );

    }
}


WorkPage.propTypes = {
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {   })(
    withRouter(WorkPage)
);



// WEBPACK FOOTER //
// ./src/components/homepage_new/work/WorkPage.js